<template>
	<div>
		<!-- Header -->
		<j-accordion
			class="xs-12 bb1 bc7"
			v-bind="accordionProps"
			bodyClass="bg5 p2"
		>
			<template v-slot:title>{{ $t("header_html") }}</template>
			<template v-slot:body>
				<core-rich-text-editor
					:delay="2000"
					:content="headerHtml"
					@input="updateHeader"
					fetchFilesFor="templateAssets"
				/>
			</template>
		</j-accordion>

		<!-- Body -->
		<j-accordion
			class="xs-12 bb1 bc7"
			:startOpen="true"
			v-bind="accordionProps"
			bodyClass="bg5 p2"
		>
			<template v-slot:title>{{ $t("body_html") }}</template>
			<template v-slot:body>
				<core-rich-text-editor
					:content="bodyHtml"
					@input="updateBody"
					fetchFilesFor="templateAssets"
				/>
			</template>
		</j-accordion>

		<!-- Footer -->
		<j-accordion
			class="xs-12 bb1 bc7"
			v-bind="accordionProps"
			bodyClass="bg5 p2"
		>
			<template v-slot:title>{{ $t("footer_html") }}</template>
			<template v-slot:body>
				<core-rich-text-editor
					:content="footerHtml"
					@input="updateFooter"
					fetchFilesFor="templateAssets"
				/>
			</template>
		</j-accordion>
	</div>
</template>

<script>
import JAccordion from "@/components/JAccordion/"
import debounce from "lodash.debounce"
import JButton from "@/components/JButton"
import api from "../../api/"

export default {
	components: {
		CoreRichTextEditor: () =>
			import("@/modules/core/components/CoreRichTextEditor/"),
		JButton,
		JAccordion
	},

	props: {
		id: String,
		payload: Object
	},

	data() {
		return {
			hasHeaderHtml: false,
			hasFooterHtml: false,
			bodyHtml: null,
			headerHtml: null,
			footerHtml: null,
			accordionProps: {
				colorWhenOpen: "bg1",
				colorWhenClosed: "bg5"
			}
		}
	},

	methods: {
		updateBody: debounce(function(value) {
			this.$emit("updateHtml", { type: "body", value })
		}, 500),

		updateHeader: debounce(function(value) {
			this.$emit("updateHtml", { type: "header", value })
		}, 500),

		updateFooter: debounce(function(value) {
			this.$emit("updateHtml", { type: "footer", value })
		}, 500)
	},

	created() {
		this.bodyHtml = this.payload.bodyHtml
		this.headerHtml = this.payload.headerSettings.html
		this.footerHtml = this.payload.footerSettings.html
	}
}
</script>

<style></style>
